import { Component, ViewChildren, QueryList, ElementRef, AfterViewInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from '../../api-authorization/authorize.service';
import { filter } from 'rxjs/operators';
import { UserModel } from '../../user.model'; // Passen Sie den Pfad an
import { NavbarService } from './navmenue.service';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements AfterViewInit {
  @ViewChild('drawer') drawer!: MatSidenav;
  @ViewChildren('navLinks') navLinks!: QueryList<ElementRef>;

  isExpanded = false;
  isAdmin = false;
  canSeePlanning = false;
  canSeeStammkunden = false;
  canSeeMeineEinsaetze = false;
  isFieldVorarbeiter = false;
  username: string | null = null;
  isNavbarVisible = true;
  isWartungExpanded: boolean = false;
  isSbomExpanded: boolean = false;

  constructor(public router: Router, public authService: AuthService, private navbarService: NavbarService) { }

  ngOnInit() {
    this.updateAdminStatus();
    this.updateUsername();
    this.navbarService.navbarVisible$.subscribe(
      isVisible => this.isNavbarVisible = isVisible
    )

    // Listen to route changes and update admin status
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateAdminStatus();
      this.updateUsername();
    });
  }

  ngAfterViewInit() {
    this.animateUnderline(); // Initial animation on page load
  }

  collapse() {
    this.isExpanded = false;
  }

  toggleWartungMenu(): void {
    this.isWartungExpanded = !this.isWartungExpanded;
  }

  toggleSbomMenu(): void {
    this.isSbomExpanded = !this.isSbomExpanded;
  }

  login() {
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/home']);
    } else {
      this.router.navigate(['/users/login']);
    }
  }

  logout() {
    this.authService.logout();
    this.updateAdminStatus();
    this.updateUsername();
    this.router.navigate(['/home']);
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  animateUnderline() {
    const activeLink = this.navLinks.find(link => link.nativeElement.classList.contains('active'));
    if (activeLink) {
      const underline = activeLink.nativeElement.querySelector('::after');
      const linkRect = activeLink.nativeElement.getBoundingClientRect();
      const offset = linkRect.left + window.scrollX;
      underline.style.left = `${offset}px`;
    }
  }

  toggleSidenav() {
    if (this.drawer) {
      this.drawer.toggle();
    }
  }

  closeSidenav() {
    if (this.drawer && this.drawer.mode !== 'side') {
      this.drawer.close();
    }
  }

  private updateAdminStatus() {
    this.isAdmin = this.authService.isAdmin();
    this.canSeePlanning = this.authService.canSeeResourcePlanning();
    this.canSeeStammkunden = this.authService.canAccessStammkunden();
    this.canSeeMeineEinsaetze = this.authService.canSeeMeineEinsaetze();
    this.isFieldVorarbeiter = this.authService.isFieldVorarbeiter();
  }

  private updateUsername() {
    if (this.authService.isAuthenticated()) {
      this.authService.getCurrentUser().subscribe(user => {
        this.username = user.username;
      });
    } else {
      this.username = null;
    }
  }
}
